import {queryOptions, useMutation, UseMutationResult, useQuery, useQueryClient, UseQueryResult} from '@tanstack/react-query';
import {createApiToken, deleteApiToken, fetchApiTokens} from '~/modules/Profile/api';
import {IApiToken, ICreatedApiToken} from '~/modules/Profile/models/ApiToken';

export const apiTokensQueryOptions = queryOptions({
    queryKey: ['api-tokens'],
    queryFn: fetchApiTokens,
});

export const useApiTokensQuery = (): UseQueryResult<IApiToken[]> =>
    useQuery(apiTokensQueryOptions);

export const useCreateApiTokenMutation = (): UseMutationResult<ICreatedApiToken, Error, string> => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: createApiToken,
        onSuccess: () => queryClient.invalidateQueries({queryKey: apiTokensQueryOptions.queryKey}),
    });
};

export const useDeleteApiTokenMutation = (): UseMutationResult<void, Error, string> => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: deleteApiToken,
        onSuccess: () => queryClient.invalidateQueries({queryKey: apiTokensQueryOptions.queryKey}),
    });
};
